import React, { useEffect, useState } from "react";
import {
  Col,
  Row,
  Button,
  ModalBody,
  Modal,
  Input,
  ModalHeader,
  ModalFooter,
  Table,
  Label,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faEye, faDownload } from "@fortawesome/free-solid-svg-icons";
import "react-datepicker/dist/react-datepicker.css";
import SidebarList from "./SidebarList";
import { useHistory } from "react-router-dom";
import "./incomeAnalyzer.scss";
import { useDispatch, useSelector } from "react-redux";
import { set_page } from "../../context/actions/general";
import { pagination } from "../../utils/constants";
import Swal from "sweetalert2";
import moment from "moment";
import Asset_Analyzer_Placeholder from '../../sample-files/Asset_Analyzer_Placeholder.pdf'
import { Formik, Form } from "formik";

import {
  getIncomeAnalyzer,
  mergeIncomeAnalyzer,
  resetIncomeAnalyzer,
  getIncomeAnalyzerCalculationSheet,
  getElasticSearchIncomeAnalyzer,
  getTaxFormsListing,
  getIncomeStatus,
  getIncomeDocList,
  sendIncomeToLoans,
  saveUnableToIncomeAnalyzerJsonData,
  saveQAVerification,
  getIncomeAnalyzerAllPdf,
} from "../../context/actions/irsIncome";
import {
  sendAnalyzerOutputToLoans, getAssetAnalyzer, getAnalyzerTypesListing,getAnalyzerAllPdf,getAnalyzerDetail, getAnalyzerOutput, getAnalyzerDocList, getElasticSearchAnalyzer,updateCompleteStatus,saveUnableToAnalysisAnalyzerJsonData,getAnalyzerValidationDetail
} from "../../context/actions/assetAnalyzer";
import NoItem from "./NoItem";
import IncomeAnalyzerModal from "./CsvModal/CsvModal";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { toasterConfig } from "../../utils/constants";
import { navigationAction } from "../../context/actions/navigationAction";
import { navigationAction2 } from "../../context/actions/navigationAction2";
import LoaderUI from "../../components/common/loader/index";
import ErrorMessage from "./ErrorMessage";
import { useLocation } from "react-router-dom";
import {
  fetchMails,
  getFileDoc,
  appendDocumentsById,
} from "../../context/actions/document";
import classnames from "classnames";
import DocumentLog from "./DocumentLog";
import UnableToAnalyze from "./UnableToAnalyze";
import { getPendingIRSIncomeDetail } from "../../context/actions/irsIncome";
import withReactContent from "sweetalert2-react-content";
const Wise = () => {
  const MySwal = withReactContent(Swal);
  const history = useHistory();
  const underwriter = useSelector((state) =>
    state?.user?.user?.roles?.permissions?.find(
      (item) => item.SLUG === "underwriter"
    )
  )
    ? true
    : false;
  const userId = useSelector((state) => state?.user?.user?._id);
  const [sidebarActivePacketIndex, setsidebarActivePacketIndex] =
    useState(null);
  const dispatch = useDispatch();
  const location = useLocation();
  let totalRecords = useSelector((state) => state.assetAnalyzer.totalRecords);
  let incomeAnalyzer = useSelector((state) => state.assetAnalyzer.records);
  const [page, setPage] = useState(pagination.page);
  const [loader, setLoader] = useState(false);
  let [status, setStatus] = useState(null);
  let [sort, setSort] = useState("createdAt");
  let [order, setOrder] = useState(-1);
  let [sortOrder, setSortOrder] = useState(2);
  let [pdfFileURL, setPdfFileURL] = useState(null);
  const [elasticSearchList, setElasticSearchList] = useState([]);
  let [analyzerDetail, setAnalyzerDetail] = useState(null);
  console.log("jhasdasgdasd", analyzerDetail);
  let [isUnableToValidateOpen, setIsUnableToValidateOpen] = useState(false);
  let [disabledUnableToDocumentFields, setDisabledUnableToDocumentFields] =
    useState(false);
  let [noRecords, setNoRecords] = useState(true);
  let [calculationSheetModal, setCalculationSheetModal] = useState(false);
  let [elasticPayload, setElasticPayload] = useState({});
  let [focusSearchFlag, setFocusSearchFlag] = useState(false);
  const [qaActiveLink, setQaActiveLink] = useState(
    analyzerDetail?.qc_status ? 1 : analyzerDetail?.qc_status === false ? 2 : 3
  );
  const [modalOpen, setModalOpen] = useState(false);
  const [heading, setHeading] = useState("");
  const [showModel, setShowModel] = useState(false);
  const [pendingIrsIncomeLoanNumber, setPendingIrsIncomeLoanNumber] =
    useState(null);
  const [pendingIrsIncomeDetail, setPendingIrsIncomeDetail] = useState(null);
  let  [analyzerValidationDetail,setAnalyzerValidationDetail] = useState(null);
  const [openIndex, setOpenIndex] = React.useState(0);
  let [activeId, setActiveId] = useState(null);
  let [payload, setPayload] = useState({
    page: 1,
    limit: 8,
    sort: "createdAt",
    order: -1,
  });
  const [initValues, setInitValues] = useState({
    error: [],
    otherreason: false,
    note: "",
  });

  useEffect(() => {
    setQaActiveLink(
      analyzerDetail?.qc_status ? 1 : analyzerDetail?.qc_status === false ? 2 : 3
    );
  }, [analyzerDetail]);
  let [internalError, setInternalError] = useState(false);
  let [taxFormsListing, setTaxFormsListing] = useState([]);
  let [analyzerTypeListing, setAnalyzerTypeListing] = useState([]);
  const [incomeStatus, setIncomeStatus] = useState({});
  const [analyzerDocList, setAnalyzerDocList] = useState({});
  const [modal, setModal] = useState(false);
  const [selectedOption, setSelectedOption] = useState("select all");
  const [time, setTime] = useState();
  const [previousTimes, setPreviousTimes] = useState([]);
  const [activeMainIndex, setActiveMainIndex] = useState(0);
  const [activeIndex, setActiveIndex] = useState(0);
  const [activeSubIndex, setActiveSubIndex] = useState(0);
  const [msg, setMsg] = useState("");
  const [contacts, setContacts] = useState([]);
  const [contactList, setContactList] = useState([]);
  const [buttonDisable, setButtonDisable] = useState(true);
  const [log, setLog] = useState("");
  const [activeTab, setActiveTab] = useState("form-view");
  const [timer, setTimer] = useState(new Date());
  const [failureReason, setFailureReason] = useState("");


  let permissions = useSelector(
    (state) => state?.user?.user?.roles?.permissions
  );
  let isQCPerson = permissions?.some((obj) => obj?.SLUG === "quality_control");

  let notify = false;

  useEffect(() => {
    setTimer(new Date());
    setLoader(true);
    dispatch(set_page(1));
    dispatch(resetIncomeAnalyzer());
    dispatch(
      getAnalyzerTypesListing((result) => {
        setLoader(false);
        setAnalyzerTypeListing(result);
        if (result && result.length) {

          setPayload({ ...payload, analyzer_type_id: result[0]?._id })
          const newPayload = {
            ...payload,
            analyzer_type_id: result[0]?._id,
            //analyzerId: location?.state?.irsIncomeId,
            // allowComplete: location?.state?.allowComplete,
          };
          location?.state?.analyzerId
            ? getAssetAnalyzerList({...newPayload,
                                    analyzerId: location?.state?.analyzerId,
                                    allowComplete: location?.state?.allowComplete})
            : getAssetAnalyzerList(newPayload);

        }
      })
    );

  }, []);

  const toggleIndex = (index) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };


  const handleAnalyzerChange = (id) => {

    setTimer(new Date());
    setLoader(true);
    dispatch(set_page(1));
    dispatch(resetIncomeAnalyzer());
    setPayload({ ...payload, analyzer_type_id: id })
    const newPayload = {
      ...payload,
      analyzer_type_id: id,
    };

    location?.state?.analyzerId
      ? getAssetAnalyzerList({...newPayload,
                              analyzerId: location?.state?.analyzerId,
                              allowComplete: location?.state?.allowComplete})
      : getAssetAnalyzerList(newPayload);

  };


  const getAssetAnalyzerList = (payload) => {
    setLoader(true);
    setInternalError(false);
    dispatch(
      getAssetAnalyzer(payload, (result) => {
        setLoader(false);
        console.log("result", result);
        if (result && result?.docs && result?.docs.length) {
          setNoRecords(false);
          // if (
          //   result?.docs[0].taxpayer_name &&
          //   result?.docs[0].taxpayer_name.length
          // ) {
          //   setActiveId(result?.docs[0].taxpayer_name[0]._id);
          //   incomeAnalyzerDetail(result?.docs[0].taxpayer_name[0].docs[0]._id);
          // } else {
          //   setActiveId(result?.docs[0]._id);
          //   getPendingIRSIncome(result?.docs[0]._id);
          // }

          if (
            result?.docs[0].borrower_name &&
            result?.docs[0].borrower_name.length
          ) {
            setActiveId(result?.docs[0].borrower_name[0].docs[0]._id);
            incomeAnalyzerDetail(result?.docs[0].borrower_name[0].docs[0]._id);

            // dispatch(getAnalyzerDocList(result?.docs[0].borrower_name[0].docs[0]._id, (data) => {
            //   setAnalyzerDocList(data)
            // }))
          }



          // dispatch(getAnalyzerOutput(result?.docs[0].borrower_name[0].docs[0]._id, (data)=>{
          // 	setIncomeStatus(data)
          // }))
          // dispatch(getIncomeDocList(result?.docs[0].taxpayer_name[0]._id, (data)=>{
          // 	setAnalyzerDocList(data)
          // }))
        } else {
          setActiveId(null);
          setNoRecords(true);
          setAnalyzerDocList({});
          setIncomeStatus({});
        }
      })
    );
  };





  const _saveUnableToAnalysisAnalyzerJsonData = (payload) => {
    setLoader(true);
    dispatch(
      saveUnableToAnalysisAnalyzerJsonData(
        activeId,
        {
          json: payload,
          validationCompletionTime: Math.round((new Date() - timer) / 1000),
          ...(Array.isArray(incomeStatus?.status?.reviewNotes) &&
            incomeStatus?.status?.reviewNotes.length !== 0 && {
            reviewNotes: incomeStatus.status.reviewNotes,
          }),
        },
        (result) => {
          if (result.success == true) {
            setTimer(new Date());
            setLog("Unable to Analyze");
            setTime(result.currentDate);
            setAnalyzerDetail({ ...analyzerDetail, unable_to_calculate_income: true });
          } else {
            setTimer(new Date());
          }
          setLoader(false);
          setIsUnableToValidateOpen(false);
        }
      )
    );
  };

  const getAnalyzerListWitSelectedId = (payload, moreInfo) => {
    setLoader(true);
    dispatch(
      getAssetAnalyzer(payload, (result) => {
        setLoader(false);
        console.log("result", result);
        if (result && result?.docs && result?.docs.length) {
          setNoRecords(false);

          if (
            result?.docs[0].borrower_name &&
            result?.docs[0].borrower_name.length
          ) {
            setActiveId(result?.docs[0].borrower_name[0].docs[0]._id);

            dispatch(getAnalyzerDocList(result?.docs[0].borrower_name[0].docs[0]._id, (data) => {
              setAnalyzerDocList(data)
            }))
          }
        } else {
          setActiveId(null);
          setNoRecords(true);
          setAnalyzerDocList({});
          setIncomeStatus({});
        }
      })
    );
  };

  const handleClick1 = () => {
    setShowModel(true);
  };

  const handleClick = () => {
    setLoader(true);
    dispatch(
      getIncomeAnalyzerCalculationSheet(analyzerDetail?._id, async (res) => {
        setLoader(false);
        if (res?.calculationSheetBuffer) {
          const buff = Buffer.from(res?.calculationSheetBuffer);
          const file = new Blob([buff], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          let a = document.createElement("a");
          a.href = window.URL.createObjectURL(file);
          a.download = "getIncomeAnalyzerCalcul.xlsx";
          a.click();
        } else {
          toast.error(
            "An error occurred while generating the income calculation worksheet. Please contact MORi Support at MORiSupport@gettrained.ai for assistance.",
            toasterConfig
          );
        }
      })
    );
  };

  const _pdfDownload = () => {
    let a = document.createElement("a");
    a.href = pdfFileURL;
    a.download = "transcripts.pdf";
    a.click();
  };

  const markAscomplete = () => {
    MySwal.fire({
      title: "Mark as Complete",
      text: "Are you sure you want to Mark this complete?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(
          updateCompleteStatus(
            {
              analyzerId: activeId,
              validationCompletionTime: Math.round((new Date() - timer) / 1000)
              // ...(Array.isArray(incomeStatus?.status?.reviewNotes) &&
              //   incomeStatus?.status?.reviewNotes.length !== 0 && {
              //   reviewNotes: incomeStatus.status.reviewNotes,
              // }),
            },
            (res) => {
              toast.success("Analyzer Marked as Completed");
             
              setTimer(new Date());
              setTime(res.currentDate);
              setLog("Marked Complete");
           
            }
          )
        );
      }
    });
  };

  const showModal = () => {
    setShowModel(true);
  };
  const closeModal = () => {
    setShowModel(false);
  };

  const _advanceFilter = (val) => {
    console.log("sdasdada");
    setPage(1);
    setStatus(val);
    if (val == "Review") {
      setElasticPayload({
        ...elasticPayload,
        reviewRequired: true,
        status: "",
      });
      setPayload({
        ...payload,
        page: 1,
        limit: 8,
        reviewRequired: true,
        status: "",
      });
      getAssetAnalyzerList({
        ...payload,
        page: 1,
        limit: 8,
        reviewRequired: true,
        status: "",
      });
    } else {
      setElasticPayload({
        ...elasticPayload,
        status: val,
        reviewRequired: null,
      });
      setPayload({
        ...payload,
        page: 1,
        limit: 8,
        status: val,
        reviewRequired: null,
      });
      getAssetAnalyzerList({
        ...payload,
        page: 1,
        limit: 8,
        status: val,
        reviewRequired: null,
      });
    }
  };

  const __advanceFilter = (sortBy, order, sortOrder) => {
    setSort(sortBy);
    setOrder(order);
    setSortOrder(sortOrder);
    setPage(1);
    setPayload({ ...payload, page: 1, limit: 8, sort: sortBy, order: order });
    getAssetAnalyzerList({
      ...payload,
      page: 1,
      limit: 8,
      sort: sortBy,
      order: order,
    });
  };

  const _resetFilter = () => {
    setElasticPayload({});
    setFocusSearchFlag(false);
    setSort("createdAt");
    setOrder(-1);
    setStatus(null);
    setPage(1);
    setPayload({
      ...payload,
      page: 1,
      limit: 8,
      sort: "createdAt",
      order: -1,
      status: "",
      filter: null,
      reviewRequired: null,
    });
    getAssetAnalyzerList({
      ...payload,
      page: 1,
      limit: 8,
      sort: "createdAt",
      order: -1,
      status: "",
      reviewRequired: null,
      filter: null,
    });
  };

  const _handlePageChange = (page) => {
    setPage(page);
    setPayload({ ...payload, page: page });
    setLoader(true);
    dispatch(
      mergeIncomeAnalyzer({ ...payload, page: page }, (result) => {
        setLoader(false);
      })
    );
  };

  const _incomeAnalyzerSearch = (val, moreInfo) => {

    console.log('moreInfo', moreInfo, val)
    setPage(1);
    setPayload({
      ...payload,
      page: 1,
      fields: "loan_number,borrower_name",
      filter: val,
    });
    setLoader(true);
    if (moreInfo) {
      getAnalyzerListWitSelectedId(
        {
          ...payload,
          page: 1,
          fields: "loan_number,borrower_name",
          filter: val,
        },
        moreInfo
      );
    } else {
      getAssetAnalyzerList({
        ...payload,
        page: 1,
        fields: "loan_number,borrower_name",
        filter: val,
      });
    }
  };

  const incomeAnalyzerDetail = (analyzerId, mainIndex, index, subIndex) => {

    if (mainIndex != undefined && index != undefined && subIndex != undefined) {
      setActiveMainIndex(mainIndex);
      setActiveIndex(index);
      setActiveSubIndex(subIndex);
    }
    setIncomeStatus({});
    setAnalyzerDocList({});
    setLoader(true);
    setAnalyzerDetail(null);
    setActiveId(analyzerId);
    setTime();
    setLog("");
    setInternalError(false);
    setActiveTab("validation-view");
    setPendingIrsIncomeLoanNumber(null);
    setPendingIrsIncomeDetail(null);
    setPdfFileURL(null);

    dispatch(getAnalyzerDocList(analyzerId, (data) => {
      setLoader(false);
      setAnalyzerDocList(data)
    }))
    dispatch(getAnalyzerValidationDetail(analyzerId, (data) => {
      setAnalyzerValidationDetail(data);
      setLoader(false);
      //setAnalyzerDocList(data)
    }))
    dispatch(
      getAnalyzerDetail(analyzerId, async (res) => {
        if (res?.result) {
          setAnalyzerDetail(res?.result);
          const uniqueIdentifier = new Date().getTime();
          history.push(`?timestamp=${uniqueIdentifier}`);
          setTimer(new Date());
        }
        if (res?.log) {
          console.log("res?.log", res?.log);
          setLog(res?.log?.logDetail);
          setTime(res?.log?.time);
          setPreviousTimes(res?.log);
        }
        // if (res?.blobAllIncomeAnalyzerPdf) {
        //   const buff = Buffer.from(res?.blobAllIncomeAnalyzerPdf);
        //   const file = new Blob([buff], { type: "application/pdf" });
        //   setPdfFileURL(window.URL.createObjectURL(file));
        // } else {
        //   setPdfFileURL(null);
        //   //toast.error('Some Internal Ml Error, Please contact admin.', toasterConfig);
        //   setInternalError(true);
        // }

        // dispatch(
        //   getIncomeDocList(analyzerId, (docdata) => {
        //     setAnalyzerDocList(docdata);
        //     dispatch(
        //       getIncomeStatus(analyzerId, (data) => {
        //         setIncomeStatus(data);
        //         if (data?.update_unable_to_calculate_income == false) {
        //           console.log("dsdad", data);

        //           setAnalyzerDetail({
        //             ...analyzerDetail,
        //             unable_to_calculate_income: false,
        //           });
        //         }
        //         setLoader(false);
        //       })
        //     );
        //   })
        // );
      })
    );
  };


  const incomeAnalyzerPdf = (analyzerId) => {

    setLoader(true);
    setPdfFileURL(null);
    dispatch(
      getAnalyzerAllPdf(analyzerId, async (res) => {
      
        if (res?.blobAllIncomeAnalyzerPdf) {
          const buff = Buffer.from(res?.blobAllIncomeAnalyzerPdf);
          const file = new Blob([buff], { type: "application/pdf" });
          setPdfFileURL(window.URL.createObjectURL(file));
        } else {
          setPdfFileURL(null);
          setLoader(false);
          //toast.error('Some Internal Ml Error, Please contact admin.', toasterConfig);
          setInternalError(true);
        }

       
      })
    );
  };

  const getPendingIRSIncome = (loan_nmber) => {
    setIncomeStatus({});
    setAnalyzerDocList({});
    setLoader(true);
    setAnalyzerDetail(null);
    setActiveId(null);
    setLog("");
    setInternalError(false);
    setActiveTab("form-view");
    setPendingIrsIncomeLoanNumber(loan_nmber);
    setPdfFileURL(null);
    setPendingIrsIncomeDetail(null);
    dispatch(
      getPendingIRSIncomeDetail(loan_nmber, async (res) => {
        setLoader(false);
        setTimer(new Date());

        if (res?.pendingIrsIncomeDetail) {
          setPendingIrsIncomeDetail(res?.pendingIrsIncomeDetail);
        }
        if (res?.blobAllIncomeAnalyzerPdf) {
          const buff = Buffer.from(res?.blobAllIncomeAnalyzerPdf);
          const file = new Blob([buff], { type: "application/pdf" });
          setPdfFileURL(window.URL.createObjectURL(file));
        } else {
          setPdfFileURL(null);
          setInternalError(true);
        }
      })
    );
  };

  /**
   * @description funnction call to search value by elasticsearc
   * @param {string} param search value
   */

  const _elasticSearch = async (val) => {
    if (val.trim()) {
      elasticPayload = { ...elasticPayload, name: val };
      setElasticPayload(elasticPayload);
      await dispatch(
        getElasticSearchAnalyzer(elasticPayload, (result) => {
          let results = result?.hits?.hits.filter((item) => {
            return item;
          });
          setElasticSearchList(results);

          setFocusSearchFlag(true);
        })
      );
    } else {
      setElasticSearchList([]);
    }
  };

  const toggleModal = () => {
    if (!modal) {
      setContacts([]);
      dispatch(
        fetchMails({ loanNumber: analyzerDocList?.loanNumber }, (res) => {
          if (res.errors) {
            setMsg(res.errors.msg);
          } else if (res.contacts) {
            setContacts(res.contacts);
          } else {
            setContacts([]);
          }
        })
      );
    }
    setModal(!modal);
  };

  const handleRadioClick = (option) => {
    setSelectedOption(option);
  };

  const sendLoans = (params, status) => {
    const resultArray = contacts
      .filter((contact, index) => {
        const notifyKey = `notify_${index}`;
        return params[notifyKey] === true;
      })
      .map((contact) => ({ email: contact.email }));

   // console.log("analyzerDetail", incomeStatus, analyzerDetail);

   let data = {
    ...analyzerDocList,
    output: {
      isSent: true,
      notifyContact: resultArray
    }
    // validationCompletionTime: Math.round((new Date() - timer) / 1000),
    // ...(Array.isArray(incomeStatus?.status?.reviewNotes) &&
    //   incomeStatus?.status?.reviewNotes.length !== 0 && {
    //   reviewNotes: incomeStatus.status.reviewNotes,
    // }),
  };
    if (resultArray?.length == 0) {
      toast.error("Please Select Atleast one loan contact");
      toggleModal();
    } else {
      console.log("data--->", data);
      dispatch(
        sendAnalyzerOutputToLoans(activeId, data, (res) => {
          if (res?.success == true) {
            setTimer(new Date());
            setTime(res.currentDate);
            setAnalyzerDetail({ ...analyzerDetail, sent_to_los_status: "Completed" });
            setLog("Sent Analyzer Output to Loan Contacts");
            toast.success(
              "Analyzer Output successfully sent to the loan contact(s)"
            );
          } else {
            setTimer(new Date());
            toast.error(
              "Analyzer Output not successfully sent to the loan contact(s)"
            );
          }
        })
      );
      toggleModal();
    }
  };

  const focusSearch = () => { };
  const navigationState = useSelector((state) => state.navigationReducer.isOn);
  const editorVisible = useSelector((state) => state.navigationReducer2.isOn2);

  const navigationHandler = () => {
    dispatch(navigationAction(!navigationState));
  };
  const sidebarEditorHandler = () => {
    dispatch(navigationAction2(!editorVisible));
  };
  const overClickHandler = () => {
    dispatch(navigationAction(false));
    dispatch(navigationAction2(false));
  };

  // Submit the form to ML Api
  const submitForm = () => {
    console.log("Submitted Form");
  };

  const toggle_tabs = (option) => {
    setActiveTab(option);
    if (option == "pdf-view") {

      if (activeId && pdfFileURL == null) {
        incomeAnalyzerPdf(activeId);
      }
    }
  };

  const toggleModal2 = () => {
    setModalOpen(!modalOpen);
  };

  const qaStatus = (tab) => {
    setQaActiveLink(tab);
    toggleModal2();
  };

  const handleInputChange = (event) => {
    setFailureReason(event.target.value);
  };

  const QAVerification = (status, message) => {
    if (status == true) {
      dispatch(
        saveQAVerification(
          {
            status: true,
            docId: analyzerDetail?._id,
            validationCompletionTime: Math.round((new Date() - timer) / 1000),
          },
          (res) => {
            setTimer(new Date());
          }
        )
      );
    } else if (status == false) {
      dispatch(
        saveQAVerification(
          {
            status: false,
            reason: message,
            docId: analyzerDetail?._id,
            validationCompletionTime: Math.round((new Date() - timer) / 1000),
          },
          (res) => {
            setTimer(new Date());
          }
        )
      );
    }
  };

  const handleSubmit = () => {
    if (qaActiveLink == 1) {
      QAVerification(true);
      toggleModal2();
    } else {
      if (failureReason == "" || failureReason == null) {
        toast.error("Enter a valid reason.", toasterConfig);
      } else {
        QAVerification(false, failureReason);
        toggleModal2();
      }
    }
  };

  const groupMessagesByCategory = (data) => {
    return data.reduce((acc, item) => {
      const category = item.category || ""; // Use 'withoutcategory' for items with no category
      if (!acc[category]) {
        acc[category] = [];
      }
      acc[category].push(item.detailedErrorMessage);
      return acc;
    }, {});
  };

  const openDocumentDirectlyInNewTab = (docId) => {
    if (!docId) return;

    dispatch(
      getFileDoc({ docId: docId.toString() }, (result) => {
        if (result && Object.keys(result).length) {
          dispatch({ type: "INCOME_DOCUMENTS_REDIRECT", data: [result] });

          setTimeout(() => {
            const newTab = window.open("/documentDetail", "_blank");
            if (!newTab) {
              toast.error("Popup blocked! Please allow popups for this site.");
            }
          }, 100);
        } else {
          toast.success("The file is already archived", toasterConfig);
          window.open("/documents", "_blank");
        }
      })
    );
  };

 


  const downloadAnalyzerOutPut = () => {
    setLoader(true);
    dispatch(getAnalyzerOutput(payload?.analyzer_type_id, (res) => {
      setLoader(false);
      if (res?.analyzerOutput) {
        const buff = Buffer.from(res?.analyzerOutput);
        const file = new Blob([buff], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        let a = document.createElement("a");
        a.href = window.URL.createObjectURL(file);
        a.download = "Asset_Analyzer_Output.xlsx";
        a.click();
        toast.success(
          "Asset Analyzer Output downloaded successfully.",
          toasterConfig
        );
      } else {
        toast.error(
          "An error occurred while generating the analyzer output. Please contact MORi Support at MORiSupport@gettrained.ai for assistance.",
          toasterConfig
        );
      }
    }))
  }




  let groupedMessages =
  analyzerDocList.missingDependencies && analyzerDocList.missingDependencies.length
      ? groupMessagesByCategory(
        analyzerDocList.missingDependencies.sort((a, b) => {
          // If 'a' doesn't have category, it should come first
          const hasCategoryA = a.hasOwnProperty("category");
          const hasCategoryB = b.hasOwnProperty("category");
          // Objects without category should come first
          if (!hasCategoryA && hasCategoryB) return -1;
          if (hasCategoryA && !hasCategoryB) return 1;
          return 0; // If both have or don't have the 'category' key, keep their order
        })
      )
      : {};

  return (
    <>
      <IncomeAnalyzerModal
        showModel={showModel}
        closeModal={closeModal}
        heading={heading}
      />
      <div className="page-header border-0 income-analyzer-header d-flex align-items-center responsive-menu-btn desktop-page-header">
        <h2>Asset Income Analyzer</h2>
        <div className="right-col ms-auto">
          <Button
            color="link"
            className="toggle-btn"
            onClick={navigationHandler}
          >
            <FontAwesomeIcon icon={faBars} />
          </Button>
          <Button
            color="link"
            className="toggle-btn"
            onClick={sidebarEditorHandler}
          >
            <FontAwesomeIcon icon={faEye} />
          </Button>
        </div>
      </div>
      <div className="documents-wrapper frequency-wrapper d-flex flex-fill overflow-auto position-relative">
        <div
          className={`sidebarListOverlay ${navigationState || editorVisible ? "active" : ""
            }`}
          onClick={overClickHandler}
        ></div>
        <div
          className={`
				left-col d-flex flex-column overflow-auto sidebar-list-col 
				${navigationState ? "active" : ""} 
				`}
        >
          <div className="sidebar-title validat_sidebar  asset-wise-header d-flex align-items-center justify-content-between">
            <h2>Asset Wise</h2>
            {/* <div class="dropdown">
              <a
                class="btn dropdown-toggle px-2"
                href="#"
                role="button"
                id="dropdownMenuLink"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Asset Analyzer
              </a>
              <ul class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                <li><a class="dropdown-item" href="#">Option 1</a></li>
                <li><a class="dropdown-item" href="#">Option 2</a></li>
                <li><a class="dropdown-item" href="#">Option 3</a></li>
              </ul>

            </div> */}
            <div className="from-group" id="wise">
              <select
                className="form-control wise-form-select"
                onChange={(e) => handleAnalyzerChange(e.target.value)}
              >
                {analyzerTypeListing.map((item, i) => {
                  return (
                    <option key={item._id} value={item._id}>
                      {item?.analyzer_type_name}
                    </option>
                  );
                })}
              </select>
            </div>
          </div>
          {incomeAnalyzer && (
            <SidebarList
              activeId={activeId}
              _resetFilter={_resetFilter}
              //sidebarLoading={sidebarLoading}
              // sidebarLoadingLabel={sidebarLoadingLabel}
              //  sidbarLoadingButton={sidbarLoadingButton}
              page={page}
              handlePageChange={(page) => _handlePageChange(page)}
              _filter={_advanceFilter}
              __filter={(sortBy, order, sortOrder) =>
                __advanceFilter(sortBy, order, sortOrder)
              }
              search={(val, moreInfo) => _incomeAnalyzerSearch(val, moreInfo)}
              //menu="document" _innerLodder={innerLoader}
              handleElasticSearch={(val) => _elasticSearch(val)}
              elasticSearchList={elasticSearchList}
              focusSearchFlag={focusSearchFlag}
              _focusSearch={(val) => focusSearch(val)}
              // filter={filter}
              _sidebarActivePacketIndex={sidebarActivePacketIndex}
              list={incomeAnalyzer}
              totalRecords={totalRecords}
              status={status}
              sort={sort}
              order={order}
              sortOrder={sortOrder}
              incomeAnalyzerDetail={(analyzerId, mainIndex, index, subIndex) =>
                incomeAnalyzerDetail(analyzerId, mainIndex, index, subIndex)
              }
              getPendingIRSIncome={(loan_nmber) =>
                getPendingIRSIncome(loan_nmber)
              }
              pendingIrsIncomeLoanNumber={pendingIrsIncomeLoanNumber}
            />
          )}
        </div>

        <div className="w-100">
          <div className="d-flex p-3 gap-3 justify-content-end analyze_btn">
             <button type="button"  className="send-btn"  disabled={analyzerDetail?.status == 'Ready for Analysis' ? false : true } onClick={()=>toggleModal()}>
             <i class="fa-solid fa-share" style={{ marginRight: "3px" }}></i> 
               Send Analyzer Output to Loan Contact(s)
            </button>
            <Modal
              isOpen={modal}
              toggle={toggleModal}
              className="role-based-login-modal"
              size="lg"
            >
              <Formik
                initialValues={initValues}
                enableReinitialize
                onSubmit={sendLoans}
              >
                {(formik) => (
                  <Form>
                    <ModalHeader>
                      Select Loan Contacts
                      <Button
                        color="link"
                        onClick={toggleModal}
                        className="close-btn"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="34"
                          height="34"
                          viewBox="0 0 34 34"
                        >
                          <g
                            data-name="Group 651"
                            transform="translate(-1535 -134)"
                          >
                            <g
                              fill="#fff"
                              stroke="#000"
                              strokeWidth="2"
                              data-name="Ellipse 30"
                              opacity="0.3"
                              transform="translate(1535 134)"
                            >
                              <circle cx="17" cy="17" r="17" stroke="none"></circle>
                              <circle cx="17" cy="17" r="16" fill="none"></circle>
                            </g>
                            <path
                              d="M19.589 18l4.8-4.8a1.124 1.124 0 00-1.589-1.584l-4.8 4.8-4.8-4.8a1.124 1.124 0 10-1.584 1.584l4.8 4.8-4.8 4.8a1.124 1.124 0 001.584 1.584l4.8-4.8 4.8 4.8a1.124 1.124 0 101.584-1.584z"
                              data-name="Icon ionic-ios-close"
                              opacity="0.3"
                              transform="translate(1534.289 132.789)"
                            ></path>
                          </g>
                        </svg>
                      </Button>
                    </ModalHeader>
                    <ModalBody>
                      <div className="loan-contacts-list">
                        {msg && <span className="txt">{msg}</span>}
                        <div className="list-items d-flex flex-wrap">
                          {contacts &&
                            contacts.map((contact, i) => {
                              return (
                                <>
                                  <Label key={i} className="">
                                    <Input
                                      type="checkbox"
                                      name={`notify_${i}`}
                                      // defaultChecked={notify ? true : false}
                                      checked={formik.values[`notify_${i}`]}
                                      // disabled={disabledForm}
                                      onChange={(e) => {
                                        if (!e.target.checked) {
                                          formik.setFieldValue("notify", false);
                                          formik.setFieldValue(
                                            `notify_${i}`,
                                            false
                                          );
                                          setContactList((prevValue) =>
                                            prevValue.filter(
                                              (c) => c.email !== contact.email
                                            )
                                          );
                                        } else {
                                          formik.setFieldValue(
                                            `notify_${i}`,
                                            e.target.checked
                                          );
                                          setContactList((prevValue) => [
                                            ...prevValue,
                                            { email: contact.email },
                                          ]);
                                          if (
                                            contacts.length ===
                                            contactList.length + 1
                                          ) {
                                            formik.setFieldValue("notify", true);
                                          }
                                        }
                                      }}
                                    />
                                    <span className="txt">
                                      {contact.role} : {contact.email}
                                    </span>
                                  </Label>
                                </>
                              );
                            })}
                        </div>
                      </div>
                    </ModalBody>
                    <ModalFooter>
                      <Label className="notify-cell">
                        <Input
                          type="checkbox"
                          name="notify"
                          defaultChecked={notify ? true : false}
                          checked={formik.values[`notify`]}
                          disabled={msg ? true : false}
                          onChange={(e) => {
                            formik.setFieldValue("notify", e.target.checked);
                            if (e.target.checked) {
                              contacts.forEach((contact, i) => {
                                formik.setFieldValue(`notify_${i}`, true);
                                setContactList((prevValue) => [
                                  ...prevValue,
                                  { email: contact.email },
                                ]);
                              });
                            } else {
                              contacts.forEach((contact, i) => {
                                formik.setFieldValue(`notify_${i}`, false);
                                setContactList([]);
                              });
                            }
                          }}
                        />
                        <span className="txt" style={{ marginLeft: "4px" }}>
                          {"Notify all contacts"}
                        </span>
                      </Label>
                      <Button
                        color="secondary"
                        type="submit"
                        disabled={msg ? true : false}
                      >
                         Send Analyzer Output to Loan Contact(s)
                      </Button>
                    </ModalFooter>
                  </Form>
                )}
              </Formik>
            </Modal>
                          
          
            <button type="button" onClick={() => {
              setIsUnableToValidateOpen(true);
            }}>
              <i class="fa-solid fa-triangle-exclamation"></i> Unable to
              Analyze
            </button>

            <UnableToAnalyze
              title={"Reasons Analysis Cannot be Calculated"}
              disabledForm={disabledUnableToDocumentFields}
              showModel={isUnableToValidateOpen}
              _toggle={() => setIsUnableToValidateOpen(false)}
              currentFile={analyzerDocList}
              _saveUnableToAnalysisAnalyzerJsonData={(data) => _saveUnableToAnalysisAnalyzerJsonData(data)}
            />
            <button type="button" onClick={markAscomplete}>
              <i class="fa-solid fa-check"></i> Mark Complete
            </button>
            

          </div>
          <div className="d-flex w-100 ">
            <div className="mid-col validatmid d-flex flex-column flex-fill overflow-auto pt-3 col-md-9">
              <div className="income-form-row d-flex">
                <div className="inner flex-fill d-flex align-items-center ">
                  <Nav tabs>
                    <NavItem>
                      <NavLink
                        className={classnames({
                          active: activeTab === "validation-view",
                        })}
                        onClick={(e) => {
                          toggle_tabs("validation-view");
                        }}
                        style={{
                          color:
                            activeTab === "validation-view" ? "blue" : "gray",
                        }}
                      >
                        Validations
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({
                          active: activeTab === "output",
                        })}
                        onClick={(e) => {
                          toggle_tabs("output");
                        }}
                        style={{
                          color: activeTab === "output" ? "blue" : "gray",
                        }}
                      >
                        Output
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({
                          active: activeTab === "pdf-view",
                        })}
                        onClick={(e) => {
                          toggle_tabs("pdf-view");
                        }}
                        style={{
                          color: activeTab === "pdf-view" ? "blue" : "gray",
                        }}
                      >
                        PDF View
                      </NavLink>
                    </NavItem>

                    <NavItem>
                      <NavLink
                        className={classnames({
                          active: activeTab === "audit-log",
                        })}
                        onClick={(e) => {
                            toggle_tabs("audit-log");
                        }}
                        style={{
                          color: activeTab === "audit-log" ? "blue" : "gray",
                        }}
                      >
                        Audit Log
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <div
                    className={`pdf-filter-btns d-inline-flex align-items-center justify-content-end`}
                  >
                    {isQCPerson && analyzerDetail?.quality_control ? (
                      <div className="btn-col ms-auto d-inline-flex align-items-center">
                        <span style={{ margin: "0px 10px" }}>QC Review</span>
                        {/* {console.log('button active link -->', activeLink)} */}
                        <Button
                          className={`btn ${qaActiveLink !== 1
                            ? "btn-outline-success"
                            : "btn-success"
                            }`}
                          onClick={() => qaStatus(1)}
                          color="link"
                          data-toggle="tooltip"
                          data-placement="top"
                          title={qaActiveLink == 1 ? "PASSED" : "PASS"}
                        >
                          PASS
                        </Button>
                        <Button
                          className={`btn ${qaActiveLink !== 2
                            ? "btn-outline-danger"
                            : "btn-danger"
                            }`}
                          onClick={() => qaStatus(2)}
                          color="link"
                          data-toggle="tooltip"
                          data-placement="top"
                          title={qaActiveLink == 2 ? "FAILED" : "FAIL"}
                        >
                          FAIL
                        </Button>
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
              {loader && (
                <LoaderUI
                  message={false}
                  FullWindow={false}
                  inContainer={true}
                />
              )}
              <TabContent activeTab={activeTab} style={{ height: "100%" }}>
                {activeTab == "validation-view" && activeId ? (
                  <div className="p-4 validation_sec">
                    <div className="d-flex justify-content-between align-items-center validat_head_main mb-5">
                      <div className="validation_head">
                        <h4>Asset Analyzer Report</h4>
                        {log === "Sent Analyzer Output to Loan Contacts" && (
                          <p>Analyzer Status:{" "}
                            <span
                              className="ready-msg text-success"
                              style={{ fontWeight: "bold" }}
                            >
                              Analyzer Output sent{" "}
                              {moment(time).format("MM/DD/YYYY h:mm A")}
                            </span>
                          </p>
                        )}

                        {log === "Unable to Analyze" && (
                          <p>Analyzer Status:{" "}
                            <span
                              className="ready-msg text-danger"
                              style={{ fontWeight: "bold" }}
                            >
                              Unable to Analyze sent{" "}
                              {moment(time).format("MM/DD/YYYY h:mm A")}
                            </span>
                          </p>
                        )}
                          {log === "Marked Complete" && (
                          <p>Analyzer Status:{" "}
                            <span
                              className="ready-msg text-success"
                              style={{ fontWeight: "bold" }}
                            >
                              Marked Complete{" "}
                              {moment(time).format("MM/DD/YYYY h:mm A")}
                            </span>
                          </p>
                        )}
                      </div>
                    </div>

                    {analyzerValidationDetail && analyzerValidationDetail?.documents?.map((doc, index) => (
                      <div className="validat_table mb-4" key={doc?.documentId}>
                        {/* Document Header */}
                        <div className="verified_head d-flex align-items-center gap-2 cursor-pointer" onClick={() => toggleIndex(index)}>
                          <h4 className="mb-0">
                            <i className={`fa-solid ${openIndex === index ? "fa-caret-down" : "fa-caret-right"
                              } me-2`}></i>
                            {doc.displayName}
                          </h4>
                          <div className="d-flex gap-3">
                            <span class="badge  common_badge danger_badge">{doc?.errorCount} Error</span>
                            <span class="badge common_badge warning_badge">{doc?.warningCount} Warning</span>

                          </div>
                        </div>
                        {openIndex === index && (
                          <>
                            {/* Validation Issues */}
                            {doc.validationIssues?.length > 0 && (

                              <div class="accordion custom-gray-accordion" id="accordionExample">
                                <div class="accordion-item">
                                  <h2 class="accordion-header">
                                    <button
                                      class="accordion-button"
                                      type="button"
                                      data-bs-toggle="collapse"
                                      data-bs-target="#collapseOne"
                                      aria-expanded="true"
                                      aria-controls="collapseOne"
                                    >
                                      <h5>{doc?.validationIssues?.length} Validation Issues Detected </h5>
                                    </button>
                                  </h2>

                                  <div
                                    id="collapseOne"
                                    class="accordion-collapse collapse show"
                                    data-bs-parent="#accordionExample"
                                  >
                                    <div class="accordion-body">
                                      {doc?.validationIssues.map((issue, index) => (
                                        <div key={index} className="alert alert-light border mb-2">
                                          <h5 className="mb-1">{issue.title}</h5>
                                          <p className="mb-0 text-muted">{issue.message}</p>
                                        </div>
                                      ))}
                                    </div>
                                  </div>
                                </div>
                              </div>

                            )}
                            {/* Large Deposits */}
                            <div className="validat_deposit mt-4">
                              <div className="d-flex align-items-center justify-content-between validat_add mb-3">
                                <h4 className="mb-0">Large Deposits Identified</h4>
                              </div>

                              <div className="table-responsive">
                                <table className="table">
                                  <thead>
                                    <tr>
                                      <th>Date</th>
                                      <th>Description</th>
                                      <th>Amount</th>
                                      <th>Action</th>
                                    </tr>
                                  </thead>

                                  <tbody>
                                    {doc.accounts?.flatMap((account) =>
                                      account.largeDeposits?.map((deposit, idx) => (
                                        <tr key={`${account.accountId}-${idx}`}>
                                          <td>{deposit.date}</td>
                                          <td>{deposit.description}</td>
                                          <td>${deposit.amount.toFixed(2)}</td>
                                          <td>
                                            <i className="fa-solid fa-pen text-muted me-3"></i>
                                            <i className="fa-solid fa-trash-can text-muted"></i>
                                          </td>
                                        </tr>
                                      ))
                                    )}

                                    {/* Empty State */}
                                    {doc.accounts?.every(
                                      (acc) => !acc.largeDeposits || acc.largeDeposits.length === 0
                                    ) && (
                                        <tr>
                                          <td colSpan="4" className="text-center text-muted">
                                            No large deposits identified
                                          </td>
                                        </tr>
                                      )}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </>
                        )}
                      </div>
                    ))}

                    {/* <div className="validat_table mt-4">
                      <div className="verified_head summary d-flex align-items-center justify-content-between">
                        <h4 className="mb-0">Validation Summary</h4>
                        <div className="analyze_btn">
                          <button type="button">
                            <i class="fa-solid fa-pen"></i> Edit
                          </button>
                        </div>
                      </div>
                      <ul>
                        <li className="d-flex align-items-center ">
                          <div className="me-3">
                            <i class="fa-solid fa-check"></i>
                          </div>
                          No bounced checks
                        </li>
                        <li className="d-flex align-items-center ">
                          <div className="me-3">
                            <i class="fa-solid fa-check"></i>
                          </div>
                          Consistent payroll deposits
                        </li>
                      </ul>
                    </div> */}

                  </div>
                ) : null}

                {activeTab == "output" && activeId ? (

                  <div className="p-4 validation_sec">
                    <div className="d-flex justify-content-between align-items-center validat_head_main">

                      <div className="analyze_btn d-flex gap-3">
                        <button type="button" onClick={() => downloadAnalyzerOutPut()}>
                          <i class="fa-solid fa-file-excel"></i> Download xlsx
                        </button>

                      </div>


                    </div>
                    <iframe
                      src={Asset_Analyzer_Placeholder}
                      width="100%"
                      height="600px"
                      title="Static PDF"
                    />


                  </div>
                  // <div className="p-4 validation_sec">
                  //   <div className="output_sec mt-4">
                  //     <div className="output_asset_title mb-5">
                  //       <h2 className="text-center mb-3">
                  //         ASSET VERIFICATION CHECKLIST
                  //       </h2>
                  //       <ul className="text-center">
                  //         <li>Loan Application #230259989</li>
                  //         <li>Borrower: Mary Lamb</li>
                  //         <li>Analysis Date: January 15, 2025</li>
                  //       </ul>
                  //     </div>
                  //     <h3 className="mb-2">BANK STATEMENT VERIFICATION</h3>
                  //     <ul className="out_bank">
                  //       <li>
                  //         <div class="form-check">
                  //           <input
                  //             class="form-check-input"
                  //             type="checkbox"
                  //             value=""
                  //             id="flexCheckDefault"
                  //           />
                  //           <label
                  //             class="form-check-label"
                  //             for="flexCheckDefault"
                  //           >
                  //             No bounced checks identified
                  //             <span className="d-block">
                  //               All trnasections cleared successfully{" "}
                  //             </span>
                  //           </label>
                  //         </div>
                  //       </li>
                  //       <li>
                  //         <div class="form-check">
                  //           <input
                  //             class="form-check-input"
                  //             type="checkbox"
                  //             value=""
                  //             id="flexCheckDefault"
                  //           />
                  //           <label
                  //             class="form-check-label"
                  //             for="flexCheckDefault"
                  //           >
                  //             No bounced checks identified
                  //             <span className="d-block">
                  //               All trnasections cleared successfully{" "}
                  //             </span>
                  //           </label>
                  //         </div>
                  //       </li>
                  //       <li>
                  //         <div class="form-check">
                  //           <input
                  //             class="form-check-input"
                  //             type="checkbox"
                  //             value=""
                  //             id="flexCheckDefault"
                  //           />
                  //           <label
                  //             class="form-check-label"
                  //             for="flexCheckDefault"
                  //           >
                  //             No bounced checks identified
                  //             <span className="d-block">
                  //               All trnasections cleared successfully{" "}
                  //             </span>
                  //           </label>
                  //         </div>
                  //       </li>
                  //       <li>
                  //         <div class="form-check">
                  //           <input
                  //             class="form-check-input"
                  //             type="checkbox"
                  //             value=""
                  //             id="flexCheckDefault"
                  //           />
                  //           <label
                  //             class="form-check-label"
                  //             for="flexCheckDefault"
                  //           >
                  //             No bounced checks identified
                  //             <span className="d-block">
                  //               All trnasections cleared successfully{" "}
                  //             </span>
                  //           </label>
                  //         </div>
                  //       </li>
                  //       <li>
                  //         <div class="form-check">
                  //           <input
                  //             class="form-check-input"
                  //             type="checkbox"
                  //             value=""
                  //             id="flexCheckDefault"
                  //           />
                  //           <label
                  //             class="form-check-label"
                  //             for="flexCheckDefault"
                  //           >
                  //             No bounced checks identified
                  //             <span className="d-block">
                  //               All trnasections cleared successfully{" "}
                  //             </span>
                  //           </label>
                  //         </div>
                  //       </li>
                  //     </ul>
                  //     <h3 className="mb-2 mt-2">ASSET DOCUMENTAION</h3>
                  //     <ul className="out_bank">
                  //       <li>
                  //         <div class="form-check">
                  //           <input
                  //             class="form-check-input"
                  //             type="checkbox"
                  //             value=""
                  //             id="flexCheckDefault"
                  //           />
                  //           <label
                  //             class="form-check-label"
                  //             for="flexCheckDefault"
                  //           >
                  //             No bounced checks identified
                  //             <span className="d-block">
                  //               All trnasections cleared successfully{" "}
                  //             </span>
                  //           </label>
                  //         </div>
                  //       </li>
                  //       <li>
                  //         <div class="form-check">
                  //           <input
                  //             class="form-check-input"
                  //             type="checkbox"
                  //             value=""
                  //             id="flexCheckDefault"
                  //           />
                  //           <label
                  //             class="form-check-label"
                  //             for="flexCheckDefault"
                  //           >
                  //             No bounced checks identified
                  //             <span className="d-block">
                  //               All trnasections cleared successfully{" "}
                  //             </span>
                  //           </label>
                  //         </div>
                  //       </li>
                  //     </ul>
                  //   </div>
                  // </div>
                ) : null}
                {activeTab == "pdf-view" ? (
                  <TabPane tabId="pdf-view" style={{ height: "100%" }}>
                    {!noRecords && analyzerDetail  &&
                      pdfFileURL && (
                        <>
                          <div className="d-flex align-items-center loan-number-title">
                            {analyzerDetail && (
                              <div className="left-col">
                                {analyzerDetail?.record_label} -{" "}
                                {analyzerDetail?.borrower_name} - Loan #{" "}
                                {analyzerDetail?.loan_number}
                              </div>
                            )}
                            {/* {pendingIrsIncomeDetail && (
                              <div className="left-col">
                                {"Pending"} - Loan #{" "}
                                {pendingIrsIncomeDetail?.loanNumber}
                              </div>
                            )} */}

                            <div className="right-col ms-auto">
                              <Button
                                color="link"
                                onClick={() => _pdfDownload()}
                                className="btn-outline-secondary download-btn"
                              >
                                <FontAwesomeIcon icon={faDownload} />
                                Download PDF
                              </Button>
                            </div>
                          </div>
                          {pdfFileURL ? (
                            <iframe
                              src={`${pdfFileURL}#view=FitH`}
                              type="application/pdf"
                              height="100%"
                              width="100%"
                              onLoad={() => setLoader(false)}
                            ></iframe>
                          ) : (
                            ""
                          )}
                        </>
                      )}
                    {noRecords && <NoItem />}
                    {internalError && (
                      <ErrorMessage className="h-auto" data={internalError} />
                    )}
                  </TabPane>
                ) : null}
                {activeTab == "form-view" ? (
                  <TabPane tabId="form-view" style={{ height: "100%" }}>
                    {!noRecords &&
                      (analyzerDetail || pendingIrsIncomeDetail) &&
                      pdfFileURL && (
                        <>
                          <div className="d-flex align-items-center loan-number-title">
                            {analyzerDetail && (
                              <div className="left-col">
                                {analyzerDetail?.employer_name} -{" "}
                                {analyzerDetail?.taxpayer_name} - Loan #{" "}
                                {analyzerDetail?.loan_number}
                              </div>
                            )}
                            {pendingIrsIncomeDetail && (
                              <div className="left-col">
                                {"Pending"} - Loan #{" "}
                                {pendingIrsIncomeDetail?.loanNumber}
                              </div>
                            )}

                            <div className="right-col ms-auto">
                              <Button
                                color="link"
                                onClick={() => _pdfDownload()}
                                className="btn-outline-secondary download-btn"
                              >
                                <FontAwesomeIcon icon={faDownload} />
                                Download PDF
                              </Button>
                            </div>
                          </div>
                          {pdfFileURL ? (
                            <iframe
                              src={`${pdfFileURL}#view=FitH`}
                              type="application/pdf"
                              height="100%"
                              width="100%"
                            ></iframe>
                          ) : (
                            ""
                          )}
                        </>
                      )}
                    {noRecords && <NoItem />}
                    {internalError && (
                      <ErrorMessage className="h-auto" data={internalError} />
                    )}
                  </TabPane>
                ) : null}
                {activeTab == "audit-log" && activeId ? (
                  <TabPane
                    tabId="audit-log"
                    className="audit-log-list position-relative"
                  >
                    {!noRecords && (
                      <DocumentLog incomeData={analyzerDetail} activeId={activeId} />
                    )}
                  </TabPane>
                ) : null}
              </TabContent>
            </div>
            {!noRecords && (
              <div
                className={`right-col  sidebar-editor-col d-flex flex-column pt-3 col-md-3 ${editorVisible ? "active" : ""
                  }`}
              >
                <div className="loan-doc-info-wrapper ">



                  {Object.keys(analyzerDocList).length !== 0 &&
                    analyzerDocList?.receivedDocuments?.length > 0 && (
                      <>
                        <h4 className="mb-4">Documents Provided</h4>
                        <ul className="docu_provide">
                          {analyzerDocList?.receivedDocuments?.map((item, index) => {
                            return (

                              <li key={index} className="d-flex  align-items-center justify-content-between gap-3">
                                <div className="stat_head">
                                  <h5>
                                    {item?.moriDocId	 ? (
                                      <a
                                        href="#"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          openDocumentDirectlyInNewTab(item.moriDocId	);
                                        }}
                                      >
                                        {item.formName}
                                      </a>
                                    ) : (
                                      item.formName
                                    )}
                                  </h5>
                                  <p className="mb-0">
                                    {item?.label ? item?.label : null}
                                  </p>
                                  <p className="mb-0">
                                    {item?.priorityDate ?
                                      moment(item?.priorityDate).format("MM/DD/YYYY") +
                                      " " +
                                      moment(item?.priorityDate).format("h:mm A") : null}
                                  </p>

                                  {/* <p className="mb-0">
                              Chase Checking 08/01/2025 - 08/31/2025
                            </p> */}
                                </div>
                                {item?.status == 'Unable to Validate' ?
                                  (<button type="button" className="text-warning arch_dot">
                                    <i class="fa-solid fa-check"></i> {item?.status}
                                  </button>) :
                                  (<button type="button" className="text-success">
                                    <i class="fa-solid fa-check"></i> {item?.status}
                                  </button>)
                                }
                              </li>

                            );
                          })}

                          {/* <li className="d-flex  align-items-center justify-content-between gap-3">
                      <div className="stat_head">
                        <h5>401K Statement</h5>
                        <p className="mb-0">PNC Bank</p>
                      </div>
                      <button type="button" className="text-success">
                        <i class="fa-solid fa-check"></i> Include
                      </button>
                    </li>
                    <li className="d-flex  align-items-center justify-content-between gap-3">
                      <div className="stat_head">
                        <h5>Tax Returns</h5>
                        <p className="mb-0">2023 missing</p>
                      </div>
                      <button type="button" className="text-warning arch_dot">
                        <span></span>Archived
                      </button>
                    </li>
                    <li className="d-flex  align-items-center justify-content-between gap-3">
                      <div className="stat_head">
                        <h5>Bank Statement</h5>
                        <p className="mb-0">
                          Chase Checking 07/01/2025 - 07/31/2025
                        </p>
                      </div>
                      <button type="button" className="text-success">
                        <i class="fa-solid fa-check"></i> Include
                      </button>
                    </li>
                    <li className="d-flex  align-items-center justify-content-between gap-3">
                      <div className="stat_head">
                        <h5>IRA Statement</h5>
                        <p className="mb-0">Received 01/15/2025</p>
                      </div>
                      <button type="button" className="text-success">
                        <i class="fa-solid fa-check"></i> Include
                      </button>
                    </li>  */}

                        </ul>
                      </>

                    )}




                  {analyzerDocList &&
                    Object.keys(analyzerDocList).length !== 0 &&
                    analyzerDocList?.missingDependencies?.length > 0 && (
                      <>
                        <h4 className="text-danger mb-3">Missing Dependencies</h4>

                        <div className="inner">
                    {Object.keys(groupedMessages).map((category,i) => (
                      <div key={i} className="miss_depend mb-3">
                        <b>{category === 'withoutcategory' ? 'Without Category' : category}</b>
                        <ul className="doc-list mb-0">
                          {groupedMessages[category].map((message, index) => (
                            <li key={index}  className="missing-message">
                                <span>{message}</span>
                            </li>
                            
                          ))}
                        </ul>
                      </div>
                    ))}
                  </div>

                        {/* {analyzerDocList.missingDependencies.map((item, index) => (
                          <div key={index} className="miss_depend mb-3">
                            <h5>{item?.category}</h5>
                            <p className="mb-0">{item?.errorMessage}</p>
                          </div>
                        ))} */}
                      </>
                    )}


                  
                  {/* <div className="miss_depend mb-3">
                    <h5>Bank Statement - Savings</h5>
                    <p className="mb-0">Savings statement required</p>
                  </div>
                  <div className="miss_depend">
                    <h5 className="mb-0">401K Statement </h5>
                  </div> */}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Wise;
